module.exports = __webpack_public_path__ + "img/symbol_5.edfe17b9.png";